import {
	HStack,
	IconAvatar,
	IconCompany,
} from '@montel/montelpro-shared-components-v2';
import { EllipsisText } from 'components/tables/EllipsisText';
import { Subscription } from 'domain/subscription/interfaces/Subscription';

export const SubscriptionOwnerCell: React.FunctionComponent<{
	subscription: Subscription;
	expanded?: boolean;
}> = ({ subscription, expanded = false }) =>
	expanded ? (
		subscription.companyId ? (
			<HStack align="center" wrap="nowrap">
				<IconCompany size="lg" />
				<EllipsisText>{subscription.companyName}</EllipsisText>
			</HStack>
		) : (
			<HStack align="center" wrap="nowrap">
				<IconAvatar size="lg" />
				<EllipsisText>
					{subscription.subscribers[0]?.email}
				</EllipsisText>
			</HStack>
		)
	) : subscription.companyId ? (
		<IconCompany size="lg" />
	) : (
		<IconAvatar size="lg" />
	);
